export type HorizontalPosition = 'left' | 'center' | 'right';
